module.exports = __webpack_public_path__ + "img/logo.9ecb7b49.png";